import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { CreditAccountGateway } from '../gateway/credit-account.gateway';

export interface CreditAccountDTO {
  companyName: string;
  vat: string;
  title: string;
  firstName: string;
  surname: string;
  address: string;
  postcode: string;
  city: string;
  country: string;
  telephone: string;
  email: string;
}

@Injectable({
  providedIn: 'any',
})
export class CreditAccountFacade {
  private creditAccountGateway = inject(CreditAccountGateway);

  submitForm(formData: CreditAccountDTO): Observable<any> {
    return this.creditAccountGateway.submitForm(formData);
  }
}
